/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RiskDimension } from './RiskDimension';
import { RiskDimensionFromJSON, RiskDimensionFromJSONTyped, RiskDimensionToJSON } from './RiskDimension';

/**
 *
 * @export
 * @interface PaginatedRiskDimensionList
 */
export interface PaginatedRiskDimensionList {
  /**
   *
   * @type {number}
   * @memberof PaginatedRiskDimensionList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedRiskDimensionList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedRiskDimensionList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<RiskDimension>}
   * @memberof PaginatedRiskDimensionList
   */
  results: Array<RiskDimension>;
}

/**
 * Check if a given object implements the PaginatedRiskDimensionList interface.
 */
export function instanceOfPaginatedRiskDimensionList(value: object): value is PaginatedRiskDimensionList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedRiskDimensionListFromJSON(json: any): PaginatedRiskDimensionList {
  return PaginatedRiskDimensionListFromJSONTyped(json, false);
}

export function PaginatedRiskDimensionListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedRiskDimensionList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(RiskDimensionFromJSON),
  };
}

export function PaginatedRiskDimensionListToJSON(value?: PaginatedRiskDimensionList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(RiskDimensionToJSON),
  };
}
